import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { PdfService } from '../pdf.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { PaymentService } from '../payment.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { BottomSheet } from '../bottom.sheet';
import { LocationService } from '../location.service';
let k = 1, j = 90;
@Component({
  selector: 'app-assign-employee',
  templateUrl: './assign-employee.component.html',
  styleUrls: ['./assign-employee.component.scss'],
})
export class AssignEmployeeComponent {
  loader: boolean = true;
  users;
  userName;
  empId;
  category;
  cateName;
  cateId;
  id;
  pageEnd: boolean = false;
  type;
  search;
  cloneUsers;
  contactNbrMob;
  Uid;
  empty: boolean = false;
  active: boolean = false;
  dupUsers: any;
  clickId;
  clickId1;
  orgName;
  reqId;
  url;
  reqDetails;
  orgId;
  catId;
  packService;
  cat1Id;
  constructor(private service: ApiService,
    public handler: HandlerService,
    public pdf: PdfService,
    public bottomSheet: MatBottomSheet,
    public router: Router,
    public payment: PaymentService,
    public translate: TranslateService,
    public auth: AuthService, public location: LocationService) { }

  ionViewWillEnter() {
    this.url = window.location.href;
    this.reqId = this.url.split('/').pop();
    this.id = sessionStorage.getItem('vendor');
    this.catId = sessionStorage.getItem('catId');
    this.empId = sessionStorage.getItem('employee')
    this.getCategory();
    if (this.url.includes('packAssign-emp') || this.url.includes('manageSubAssign')) {
      this.reqId = this.url.split('/').pop();
      this.service.getCustItemSubsById(this.reqId).subscribe((res: any) => {
        this.packService = res;
      })
    }
    if (this.url.includes('assign-employee') || this.url.includes('change-Alloc')) {
      this.reqId = this.url.split('/').pop();
      this.service.getRequestById(this.reqId).subscribe((res: any) => {
        this.reqDetails = res;
      })
    }
    this.getsc();
  }
  getsc() {
    this.service.getUsersByOrgAndCate('SC', this.id, this.catId).subscribe(res => {
      this.users = res;
      this.users.map(res => {
        if (res.categoryLists)
          res.categoryLists.map(res1 => {
            if (res1.categoryId == this.catId) {
              this.cat1Id = res1.categoryId
              Object.assign(res, { vId: this.cat1Id })
            }
          })
      })
      this.users = this.users.filter(res => { return res.vId == this.catId });
      this.dupUsers = res;
      this.dupUsers.map(res => {
        if (res.categoryLists)
          res.categoryLists.map(res1 => {
            if (res1.categoryId == this.catId) {
              this.cat1Id = res1.categoryId
              Object.assign(res, { vId: this.cat1Id })
            }
          })
      })
      this.dupUsers = this.dupUsers.filter(res => { return res.vId == this.catId });
      setTimeout(() => {
        this.loader = false;
      }, 1000);
    }, err => {
      this.handler.err(err)
      this.loader = false;
    })
  }

  getUser(val) {
    this.empty = false;
    let x = val.length;
    if (x > 0) {
      this.service.searchCustomers("SC", val, this.id).subscribe((res: any) => {
        if (!this.empty) {
          this.cloneUsers = JSON.parse(JSON.stringify(res));
          this.users = JSON.parse(JSON.stringify(res));
          this.users = this.users.filter(res => { return this.cat1Id == this.catId })
        }
        else {
          this.cloneUsers = [];
          this.users = [];
          this.empty = true;
        }
      })
    } else {
      this.empty = true;
      this.users = this.dupUsers
    }
  }

  async onPageScroll($event) {
    const scrollElement = await $event.target.getScrollElement();
    const scrollHeight = scrollElement.scrollHeight - scrollElement.clientHeight;
    const currentScrollDepth = $event.detail.scrollTop;
    const targetPercent = j;
    let triggerDepth = ((scrollHeight / 100) * targetPercent);
    if (currentScrollDepth > triggerDepth) {
      if (!this.pageEnd) {
        this.getsc()
      }
      k++;
    }

  }


  ionViewWillLeave() {
    this.search = undefined;
    // sessionStorage.removeItem('catId')
    this.search = ""
  }


  accept(id) {
    this.loader = true;
    this.url = window.location.href;
    if (this.url.includes('assign-employee')) {
      let post = {
        "apptDate": this.reqDetails.apptDate,
        "serviceContractorId": id,
        "targetSource": id,
        "apptEndTime": this.reqDetails.apptEndTime,
        "apptTime": this.reqDetails.apptTime,
      }

      let url = window.location.href;
      this.service.confirmReq(this.reqId, post).subscribe(res => {
        this.loader = false;
        this.handler.res('Employee Assigned Successfully !!');
        if (url.includes('assign-employee1')) {
          this.router.navigate(['/manage-ondemand-req']);
        } else {
          this.router.navigate(['/vendor-request']);
        }

      })
    }
    if (this.url.includes('packAssign-emp')) {
      Object.assign(this.packService, {
        "serviceContractorId": id,
        "changeAllocation": false,
        "status": 6
      })
      this.service.confirmPackReq(this.reqId, this.packService).subscribe(res => {
        this.loader = false;
        this.handler.res('Employee Assigned Successfully !!');
        if (this.url.includes('packAssign-emp')) {
          this.router.navigate(['/vendor-request']);
        } else if (this.url.includes('manageSubAssign')) {
          this.router.navigate(['/vendor-subs']);
        }

      }, err => {
        this.loader = false;
        this.handler.err(err)
      })
    }
    if (this.url.includes('change-Alloc')) {
      let post = {
        "apptDate": this.reqDetails.apptDate,
        "serviceContractorId": id,
        "targetSource": id,
        "apptEndTime": this.reqDetails.apptEndTime,
        "apptTime": this.reqDetails.apptTime,
      }
      this.service.changeAllocReq(this.reqId, post).subscribe(res => {
        this.loader = false;
        this.handler.res('Employee Assigned Successfully !!');
        if (this.url.includes('change-Alloc')) {
          this.router.navigate(['/vendor-request']);
        }
        if (this.url.includes('change-Alloc1')) {
          this.router.navigate(['/manage-ondemand-req']);
        }
      }, err => {
        this.loader = false;
        this.handler.err(err)
      })
    }
    if (this.url.includes('manageSubAssign')) {
      Object.assign(this.packService, {
        "serviceContractorId": id,
        "changeAllocation": true,
        "status": 6
      })
      this.service.confirmPackReq(this.reqId, this.packService).subscribe(res => {
        this.loader = false;
        this.handler.res('Employee Assigned Successfully !!');
        this.router.navigate(['/vendor-subs']);

      }, err => {
        this.loader = false;
        this.handler.err(err)
      })
    }
    if (this.url.includes('orderEmpAssign') || this.url.includes('AssigningEmp') || this.url.includes('homeContractorAssign') || this.url.includes('contractorAssign') || this.url.includes('purchaseEmpAssign')) {
      var post = {
        "serviceContractorId": id,
        "vendorId": 790,
      }
      this.service.assignOrder(this.reqId, post).subscribe((res: any) => {
        this.loader = false;
        this.handler.res('Employee Assigned Successfully !!');
        if (this.url.includes('AssigningEmp')) {
          this.router.navigate(['/vendor-request'])
        } else if (this.url.includes('purchaseEmpAssign')) {
          this.router.navigate(['/manage-purchase']);
        } else if (this.url.includes('homeContractorAssign')) {
          this.router.navigate(['/vendor-manage-order']);
        } else if (this.url.includes('contractorAssign')) {
          this.router.navigate(['/admin-manage-order']);
        } else {
          this.router.navigate(['/manage-Order']);
        }

      }, err => {
        this.loader = false;
        this.handler.err(err)
      })
    }

  }


  cancel() {
    if (this.url.includes('manageSubAssign')) {
      this.router.navigate(['/vendor-subs']);
    } else if (this.url.includes('assign-employee1') || this.url.includes('change-Alloc1')) {
      this.router.navigate(['/manage-ondemand-req']);
    } else if (this.url.includes('orderEmpAssign')) {
      this.router.navigate(['/manage-Order']);
    } else if (this.url.includes('homeContractorAssign')) {
      this.router.navigate(['/vendor-manage-order']);
    } else if (this.url.includes('contractorAssign')) {
      this.router.navigate(['/admin-manage-order']);
    } else if (this.url.includes('purchaseEmpAssign')) {
      this.router.navigate(['/manage-purchase']);
    } else {
      this.router.navigate(['/vendor-request']);
    }

  }


  select(id) {
    if (this.clickId == id) {
      this.clickId = "";
    } else {
      this.clickId = id
    }
  }


  getCategory() {
    // this.loader = true;
    this.service.getOrgCategory().subscribe((res: any) => {
      this.category = res;
      // this.loader = false;
    })
  }

  openBottomSheetItemCategory() {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.category,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.cateName = res.name;
        this.cateId = res.id;
      }
    });
  }

}

